import React from 'react'
import styled from 'styled-components'
import Cat from '@src/images/student/cat'

const OuterWrapper = styled.div`
  top: 0;
  height: 100%;
  min-width: 612px;
  overflow-x: hidden;
  overflow-y: auto;
  position: fixed;
  width: 100%;
`

const InnerWrapper = styled.section`
  margin: 0px auto;
  width: 612px;
  background-color: #ece2d4;
  min-height: 100%;
  position: relative;
  box-sizing: border-box;
  background-color: #ece2d4;
  width: 100%;
  padding: 15px;
  color: #000;
  &, * { text-align: center; }
  font-size: 28px;
  line-height: 36px;

  a {
    color: rgba(74, 144, 226, 1);
    font-size: 15px;
    line-height: 19px;
    text-decoration: none;

    &:hover {
      color: rgba(74, 144, 226, 0.7);
    }
  }

  p {
    margin-bottom: 25px;
  }

  article {
    padding-top: 100px;
  }

  .close {
    display: inline-block;
    padding: 6px 12px;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.42857143;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    cursor: pointer;
    border: 1px solid transparent;
    border-radius: 3px;

    @media only screen and (min-width: 920px) {
      top: 240px;
    }

    @media only screen and (max-width: 919px) {
      top: 285px;
    }

    left: 50%;
    background: #70588d;
    color: white;
  }

  .intro-block {
    position: relative;
    width: 60%;
    left: 20%;
    top: 10%;
    font-weight: bold;
  }

  .photo-block {
    margin-top: 50px;
  }
`

const InappropriateGrade = ({ student }) => {
  const handleReturn = () => {
    window.location.href = window.PLATFORM_URL + '/home'
  }

  return (
    <OuterWrapper>
      <InnerWrapper>
        <article>
          <div className="intro-block">
            <p>
              {
                I18n.t('students.before_trial_tour.hello', {
                  name: student.fullName
                })
              }

              <br/>

              { I18n.t('students.inappropriate_grade.message') }
            </p>
          </div>
        </article>
        <button type="button" className="close" onClick={handleReturn}>
          { I18n.t('students.inappropriate_grade.return_to_dinolab') }
        </button>
        <div className="photo-block">
          <img src={Cat} width="183" height="127" />
        </div>
      </InnerWrapper>
    </OuterWrapper>
  )
}

export default InappropriateGrade
